"use strict";

var _slicedToArray = require("/usr/src/app/www/node_modules/@babel/runtime/helpers/slicedToArray.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.partsToUrlUnmapper = exports.partsToUrlMapper = void 0;

function partsToUrlMapper(data) {
  var _data = _slicedToArray(data, 3),
      scheme = _data[0],
      authority = _data[1],
      path = _data[2];

  var query = data[3] === null ? '' : "?".concat(data[3]);
  var fragments = data[4] === null ? '' : "#".concat(data[4]);
  return "".concat(scheme, "://").concat(authority).concat(path).concat(query).concat(fragments);
}

exports.partsToUrlMapper = partsToUrlMapper;
var UrlSplitRegex = /^([[A-Za-z][A-Za-z0-9+.-]*):\/\/([^/?#]*)([^?#]*)(\?[A-Za-z0-9\-._~!$&'()*+,;=:@/?%]*)?(#[A-Za-z0-9\-._~!$&'()*+,;=:@/?%]*)?$/;

function partsToUrlUnmapper(value) {
  if (typeof value !== 'string') {
    throw new Error('Incompatible value received: type');
  }

  var m = UrlSplitRegex.exec(value);

  if (m === null) {
    throw new Error('Incompatible value received');
  }

  var scheme = m[1];
  var authority = m[2];
  var path = m[3];
  var query = m[4];
  var fragments = m[5];
  return [scheme, authority, path, query !== undefined ? query.substring(1) : null, fragments !== undefined ? fragments.substring(1) : null];
}

exports.partsToUrlUnmapper = partsToUrlUnmapper;